var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-container"},_vm._l((_vm.list),function(option,index){return _c('span',{key:option.value,staticClass:"option",on:{"click":() => _vm.onClickSelect(option, index)}},[_vm._v(" "+_vm._s(option.label)+" "),(index === 0)?_c('img',{attrs:{"src":"/images/redesign/angle-right.svg","width":"12","height":"12"}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }